<div class="preloader">
  <div class="loader">
    <span class="inner-loader">
      <img *ngIf="property.logoUrl !== null && property.logoUrl !== undefined" [src]="property.logoUrl" alt="" />
      <img *ngIf="property.logoUrl == null || property.logoUrl == undefined" src="assets/images/Logo-kalinga.jpg" alt="" />
    </span>
  </div>
</div>

<header class="navbar-fixed">


  <app-navbar></app-navbar>
</header>
